// import Info from '@/views/info/MyInfo.vue'
// import Notice from '@/views/info/Notice.vue'

const Info = () =>
  import(/* webpackChunkName: "info" */ '@/views/info/MyInfo.vue')
const Notice = () =>
  import(/* webpackChunkName: "info" */ '@/views/info/Notice.vue')

export default function (router) {
  router.push({
    path: '/partner',
    component: Info,
    redirect: '/partner/info',
  })
  // 我的信息
  router.push({
    path: '/partner/info',
    name: 'info',
    component: Info,
    meta: {
      isDistributor: true, // 校验权限是否为渠道商
      currPage: 'partnerInfo',
    },
  })

  router.push({
    path: '/partner/invite/:id',
    name: 'invite',
    component: Notice,
    beforeEnter: async (to, from, next) => {
      if (!to.query.hideSideMenu) {
        return next({
          name: 'invite',
          params: { id: to.params.id },
          query: { ...to.query, hideSideMenu: 1 },
        })
      }
      next()
    },
  })
}
